// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".portal-animation[data-v-5069435c]{-webkit-animation:shakeX-data-v-5069435c .8s;animation:shakeX-data-v-5069435c .8s}@-webkit-keyframes shakeX-data-v-5069435c{0%,to{transform:translateZ(0)}10%,30%,50%,70%,90%{transform:translate3d(-5px,0,0)}20%,40%,60%,80%{transform:translate3d(5px,0,0)}}@keyframes shakeX-data-v-5069435c{0%,to{transform:translateZ(0)}10%,30%,50%,70%,90%{transform:translate3d(-5px,0,0)}20%,40%,60%,80%{transform:translate3d(5px,0,0)}}", ""]);
// Exports
module.exports = exports;
